import React from 'react';
import { connect } from 'react-redux';
import { Icon, Dropdown, Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { toggleCollectionDatasetsSingleSorting } from '../actions';

const CollectionDatasetsTableSettingsMenu = ({
  category,
  code,
  singleSorting,
  toggleSingleSorting,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      icon={null}
      pointing="top left"
      trigger={(
        <Button
          basic
          title={intl.formatMessage({ id: 'actions.table.settings.title' })}
          icon="cog"
          className="aridhia-collection-datasets-table-settings-menu-button"
          circular
        />
      )}
      className="aridhia-collection-datasets-table-settings-menu"
    >
      <Dropdown.Menu>
        <Dropdown.Item
          as="a"
          selected={false}
          onClick={() => toggleSingleSorting(category, code)}
        >
          <Icon name="sort alphabet down" />
          <FormattedMessage id={singleSorting ? 'actions.sort.multiple' : 'actions.sort.single'} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const mapStateToProps = ({
  collectionDatasets: { collectionDatasets },
}, { category, code }) => {
  const item = findResult(collectionDatasets, category, code);
  return ({ singleSorting: item ? item.singleSorting : [] });
};

const mapDispatchToProps = {
  toggleSingleSorting: toggleCollectionDatasetsSingleSorting,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetsTableSettingsMenu);
